module.exports = __webpack_public_path__ + "img/news_home_1.70806101.jpg";